const toLowercase = str => str.toLowerCase()

export default toLowercase



// WEBPACK FOOTER //
// ./src/assets/js/toLowercase.js